import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getSignupUrl } from '../../utils/urls';
import { trackSignupLinkClick } from '../../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SignUpLink = ({
  isFbSignin,
  signupParams,
  loginRedirectUrlQueryParam,
  pageId
}) => {
  const signupUrl = getSignupUrl(signupParams, isFbSignin, pageId, loginRedirectUrlQueryParam);
  return /*#__PURE__*/_jsxs("div", {
    className: "signup-link",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.signupLink.text"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: trackSignupLinkClick,
      href: signupUrl,
      className: "m-left-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.signupLink.cta"
      })
    })]
  });
};
export default SignUpLink;